module.exports = __webpack_public_path__ + "assets/img/welcome-1.0c0f9593.png";